<p-dialog class="flex-wrap" (onHide)="closeDialog()"
          [(visible)]="visible" [closable]="true" [modal]="true"
          [style]="{'top': '4vh',width: '60vw', height: '90vh','min-width': '400px', 'min-height': '300px','max-width': '1200px', 'max-height': '650px'}"
          [draggable]="false" [resizable]="false" closeIcon="pi pi-times loading-icon-size">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <i class="pi pi-tag text-blue-500 text-2xl"></i>
            <span class="white-space-nowrap">
                        INICIAR EVALUACIÓN - #{{selected?.numeroExpediente!}}
                </span>
        </div>
    </ng-template>
    @if (this.tramiteService.tramitesFasesEval()) {
        <div *ngIf="datosCargados; else loading">
            <p-messages severity="error" *ngIf="tramiteService.tramitesFasesEval().length==0">
                <ng-template pTemplate>
                    <div class="ml-2  text-xl">Estimado usuario, debe existir trámites para el proyecto e iniciar evaluación
                    </div>
                </ng-template>
            </p-messages>
            <p-messages severity="error" *ngIf="fasesTramitesValid()">
                <ng-template pTemplate>
                    <div class="ml-2  text-xl">Estimado usuario, no se encuentra trámites disponibles para iniciar evaluación
                    </div>
                </ng-template>
            </p-messages>
            <ng-container *ngIf="selected?.idSolicitudTipo==1 && tramiteService.tramitesFasesEval().length>0">
                <div class="field">
                    <div class="field col-12 md:col-3">
                        <p-dropdown class="xl:w-full" [options]="fasesToEval()" [(ngModel)]="selectedFases"
                                    optionLabel="nombreFase" id="idFase" placeholder="Seleccionar fase a evaluar"
                                    [tooltip]="!selectedFases && !validSelectedFase?'Seleccionar fase a evaluar':''"
                                    (onChange)="seleccionarTramitesFases($event)">
                        </p-dropdown>
                        <small *ngIf="selected?.idSolicitudTipo==1 && validSelectedFase"
                               class="ng-dirty ng-invalid block mt-2" style="color:red">
                            <b>Favor seleccione una fase</b>
                        </small>
                    </div>
                </div>
            </ng-container>
            @for (items of this.tramiteService.tramitesFasesEval(); track $index; ) {
                <b *ngIf="items.tramitesEvalResponse.length>0">
                    <div class="text-900 font-semibold mb-3">{{ items.nombreFase }} ({{ items.tramitesEvalResponse.length }})
                    </div>
                </b>
                <div class="row" *ngIf="items.tramitesEvalResponse.length>0">
                    <div>
                        <div class="field col-12">
                            <p-listbox
                                [options]="items.tramitesEvalResponse"
                                [(ngModel)]="selectedTramites"
                                optionLabel="nombreTramite"
                                [listStyle]="{'max-height': '400px', 'min-height': '40px', 'width': '100%'}"
                                [multiple]="true"
                                [metaKeySelection]="false"
                                scrollHeight="250px"
                                (onChange)="onListboxChange($event)"
                                [readonly]="selected?.idSolicitudTipo==1?true:false">
                                <ng-template let-item pTemplate="item">
                                    <div class="flex align-items-center">
                                        <p-checkbox
                                            [binary]="true"
                                            [ngModel]="isSelected(item)"
                                            [disabled]="item.estadoEval || selected?.idSolicitudTipo==1?true:false">
                                        </p-checkbox>
                                        <span class="ml-2" [pTooltip]="item.nombreTramite">{{item.nombreTramite}}</span>
                                    </div>
                                </ng-template>
                            </p-listbox>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-times" class="p-button-text" label="Cerrar" (click)="closeDialog()"></button>
        <button pButton pRipple icon="pi pi-check" class="p-button-text" label="Guardar" [disabled]="tramiteService._tramitesFasesEval().length==0 || fasesTramitesValid()"
                (click)="guardar()"></button>
    </ng-template>
</p-dialog>


